import { render } from "./Money.vue?vue&type=template&id=8cd79d5e"
import script from "./Money.vue?vue&type=script&lang=js"
export * from "./Money.vue?vue&type=script&lang=js"

import "./Money.vue?vue&type=style&index=0&id=8cd79d5e&lang=scss"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__